import { useEffect, useState } from "react";
import { TrendingUp, TrendingDown, Minus, LineChart } from "lucide-react";
import { api } from "../../lib/api";

// Variations hebdomadaires du classement Google (demande du propriétaire,
// 2026-10-16) : 7 derniers jours contre les 7 précédents, par requête —
// données Search Console. Affiché dans Admin → Marketing → Mots-clés.
export default function PositionsGoogleCard() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/admin/seo/positions-hebdo")
      .then((r) => setData(r.data))
      .catch((e) => setErr(e.response?.data?.detail || "indisponible"));
  }, []);

  const Variation = ({ v }) => {
    if (v === null || v === undefined)
      return <span className="text-[10px] uppercase tracking-widest text-ivory/40">nouveau</span>;
    if (Math.abs(v) < 0.5)
      return <span className="inline-flex items-center gap-1 text-ivory/50"><Minus className="w-3 h-3" /> stable</span>;
    return v > 0
      ? <span className="inline-flex items-center gap-1 text-emerald-300"><TrendingUp className="w-3 h-3" /> +{v}</span>
      : <span className="inline-flex items-center gap-1 text-red-300"><TrendingDown className="w-3 h-3" /> {v}</span>;
  };

  return (
    <div className="bg-surface border border-ivory/10 rounded-xl p-7 space-y-4" data-testid="positions-google-card">
      <div>
        <p className="font-semibold flex items-center gap-2">
          <LineChart className="w-4 h-4 text-gold" /> Positions Google — variation hebdomadaire
        </p>
        <p className="text-xs text-ivory/70 mt-1 max-w-xl">
          Classement de vos mots-clés principaux : 7 derniers jours contre les 7 précédents
          {data?.periode ? ` (${data.periode.du} au ${data.periode.au})` : ""}.
          Une variation positive (▲) signifie une MONTÉE dans Google.
        </p>
      </div>
      {err && <p className="text-xs text-amber-300/80" data-testid="positions-erreur">{err}</p>}
      {!err && data && !data.connected && (
        <p className="text-xs text-ivory/60" data-testid="positions-non-connecte">
          Google Search Console n'est pas connecté — branchez-le (section SEO/Google de l'admin)
          pour voir ici les positions réelles de vos mots-clés, semaine contre semaine.
        </p>
      )}
      {!err && data?.connected && (
        <div className="overflow-x-auto" data-testid="positions-tableau">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-[10px] uppercase tracking-widest text-ivory/50 text-left">
                <th className="pb-2 pr-3">Requête</th>
                <th className="pb-2 pr-3">Position</th>
                <th className="pb-2 pr-3">Variation</th>
                <th className="pb-2 pr-3">Clics</th>
                <th className="pb-2">Impressions</th>
              </tr>
            </thead>
            <tbody>
              {data.rows.map((r, i) => (
                <tr key={r.requete} data-testid={`position-row-${i}`}
                  className="border-t border-ivory/10">
                  <td className="py-2 pr-3 text-ivory/90">{r.requete}</td>
                  <td className="py-2 pr-3 text-gold font-medium">{r.position || "—"}</td>
                  <td className="py-2 pr-3"><Variation v={r.variation} /></td>
                  <td className="py-2 pr-3 text-ivory/70">{r.clics}</td>
                  <td className="py-2 text-ivory/70">{r.impressions}</td>
                </tr>
              ))}
              {data.rows.length === 0 && (
                <tr><td colSpan={5} className="py-3 text-xs text-ivory/50">
                  Aucune donnée sur cette période — Google compile encore les statistiques.
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      {!err && !data && <p className="text-xs text-ivory/50">Chargement des positions…</p>}
    </div>
  );
}
